import React from 'react';
import GetShelves from './Shelves';


export default function App(id) {
    return (
        <div className="digital-gallery">
            <GetShelves pageId={id.page} />
        </div >

    );
}